export enum TagManagerEventType {
  click = 'click',
  pageview = 'pageview',
  signup = 'signup',
  tariffCalculationSubmitted = 'tariff_calculation_submitted',
  tariffEmailSubmitted = 'tariff_email_submitted',
  tariffMeetingBooked = 'tariff_meeting_booked',
  costModelLeadSubmitted = 'cost_model_lead_submitted',
  costModelRegisterClick = 'cost_model_register_click',
}

export enum TagManagerPage {
  publicReportPage = '/public-report',
  registerPage = '/register',
}

export enum TagManagerAction {
  reportView = 'view',
  reportRequestReportAction = 'custom report request click',
  reportLearnMoreAction = 'learn more click',
  reportMuirLogoAction = 'Muir logo click',
  registerPageView = 'register page view',
  userSignup = 'user signup',
  // Whether the hero composer had a product in it when the visitor pressed
  // send. The whole point of the composer is to find out how many people are
  // willing to describe their own product before signing up, and this is the
  // number that answers it.
  heroSubmitWithProduct = 'hero submit with product',
  heroSubmitEmpty = 'hero submit empty',
}
